import React, { SVGProps } from 'react'
const SvgRecurring = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox={'0 0 24 24'}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M16.39 6.283a7.01 7.01 0 0 0-8.731.666c-1.942 1.798-2.765 4.54-2.15 7.152a.774.774 0 0 1-.738.957.761.761 0 0 1-.74-.592c-.747-3.159.25-6.477 2.603-8.66a8.469 8.469 0 0 1 6.24-2.28 8.455 8.455 0 0 1 4.595 1.632l-.06-1.605a.767.767 0 0 1 .732-.802.767.767 0 0 1 .79.744l.125 3.43v.062c0 .415-.32.755-.733.773l-3.386.128h-.02a.768.768 0 0 1-.76-.744.767.767 0 0 1 .732-.803l1.5-.058zm-6.273 12.194-1.598.147a7.01 7.01 0 0 0 8.849-.584c1.944-1.8 2.768-4.542 2.15-7.152-.1-.41.148-.829.555-.933a.762.762 0 0 1 .923.569c.747 3.16-.25 6.475-2.603 8.659-1.605 1.484-3.65 2.292-5.8 2.292a8.48 8.48 0 0 1-4.987-1.61l.132 1.527c.039.426-.267.801-.649.835a.393.393 0 0 1-.107.012.765.765 0 0 1-.757-.705l-.302-3.447a.77.77 0 0 1 .688-.841l3.365-.31c.423-.04.79.271.829.699a.77.77 0 0 1-.688.842z"
    />
  </svg>
)
export default SvgRecurring
